import { useEffect, useRef, useState } from "react";
import { Globe, Check } from "lucide-react";
import { LANGUAGES } from "@/data/site";

export const LanguageSwitcher = () => {
  const [open, setOpen] = useState(false);
  const [current, setCurrent] = useState("en");
  const ref = useRef(null);

  useEffect(() => {
    if (!document.getElementById("google-translate-script")) {
      window.googleTranslateElementInit = () => {
        new window.google.translate.TranslateElement(
          { pageLanguage: "en", autoDisplay: false },
          "google_translate_element"
        );
      };
      const s = document.createElement("script");
      s.id = "google-translate-script";
      s.src = "https://translate.google.com/translate_a/element.js?cb=googleTranslateElementInit";
      s.async = true;
      document.body.appendChild(s);
    }
    const saved = localStorage.getItem("exoplusbio-lang");
    if (saved && saved !== "en") {
      const trySet = (n) => {
        const combo = document.querySelector(".goog-te-combo");
        if (combo) {
          combo.value = saved;
          combo.dispatchEvent(new Event("change"));
          setCurrent(saved);
        } else if (n < 20) {
          setTimeout(() => trySet(n + 1), 500);
        }
      };
      trySet(0);
    }
  }, []);

  useEffect(() => {
    const onClick = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", onClick);
    return () => document.removeEventListener("mousedown", onClick);
  }, []);

  const change = (code) => {
    const combo = document.querySelector(".goog-te-combo");
    if (combo) {
      combo.value = code;
      combo.dispatchEvent(new Event("change"));
    }
    localStorage.setItem("exoplusbio-lang", code);
    setCurrent(code);
    setOpen(false);
  };

  const active = LANGUAGES.find((l) => l.code === current) || LANGUAGES[0];

  return (
    <div className="relative" ref={ref} data-testid="language-switcher">
      <div id="google_translate_element" style={{ display: "none" }} aria-hidden="true" />
      <button
        onClick={() => setOpen(!open)}
        data-testid="language-switcher-button"
        className="inline-flex items-center gap-2 border border-[#e4e9ec] px-3 py-2 text-xs font-medium text-[#0a0a0a] transition-colors hover:border-[#0a0a0a]"
        aria-haspopup="listbox"
        aria-expanded={open}
      >
        <Globe className="h-3.5 w-3.5 text-[#0e8c8c]" />
        <span className="hidden md:inline">{active.label}</span>
        <span className="font-lab md:hidden">{active.code.toUpperCase()}</span>
      </button>
      {open && (
        <ul
          role="listbox"
          data-testid="language-switcher-options"
          className="absolute right-0 top-full z-50 mt-2 max-h-72 w-44 overflow-auto border border-[#e4e9ec] bg-white py-1 shadow-xl"
        >
          {LANGUAGES.map((l) => (
            <li key={l.code}>
              <button
                onClick={() => change(l.code)}
                data-testid={`language-option-${l.code}`}
                className="flex w-full items-center justify-between px-4 py-2 text-left text-xs text-[#0a0a0a] transition-colors hover:bg-[#e3f2f0]"
              >
                {l.label}
                {current === l.code && <Check className="h-3.5 w-3.5 text-[#0e8c8c]" />}
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default LanguageSwitcher;
